import { Stack, Text } from '@mantine/core';

interface Props {
  title: string;
  text?: string;
  testId: string;
}
export const Label = ({ title, text, testId }: Props) => {
  return (
    <Stack gap={3}>
      <Text size={'sm'} color={'blue'} fw={'bold'} data-testid={`label-title-${testId}`}>
        {title}
      </Text>
      <Text size={'sm'} data-testid={`label-text-${testId}`}>
        {text}
      </Text>
    </Stack>
  );
};
